import React from 'react';

const SiteMapIntro = () => {
  return (
    <div className="text-center mb-[50px]">
      <div
        className="flex items-center justify-center mx-auto w-[80px] h-[80px] rounded-full mb-[25px] bg-gradient-to-br from-icetex to-icetex-dark"
        style={{ boxShadow: '0 10px 30px rgba(0, 63, 129, 0.3)' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-white"
          style={{ width: '40px', height: '40px' }}
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </div>
      <p
        className="text-texto-sec mx-auto"
        style={{ fontSize: '1.1rem', lineHeight: '1.8', maxWidth: '700px' }}
      >
        Encuentra rápidamente lo que buscas. Aquí está organizada toda la información
        disponible en nuestro portal para que puedas acceder fácilmente a cada sección.
      </p>
    </div>
  );
};

export default SiteMapIntro;
